import axios from "axios";
import api from "@/lib/api";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

// CS 22.0 -- one interface over HO (JWT) and partner-link (PIN session) endpoints.
export function adminCatalogApi() {
  return {
    mode: "admin",
    catalog: (params) => api.get("/master-catalog/catalog", { params }).then((r) => r.data),
    design: (params) => api.get("/master-catalog/design", { params }).then((r) => r.data),
  };
}

export function partnerCatalogApi(token, session) {
  const headers = { "X-MC-Session": session };
  const url = (p) => `${BASE}/mc/${token}${p}`;
  return {
    mode: "partner",
    catalog: (params) => axios.get(url("/catalog"), { params, headers }).then((r) => r.data),
    design: (params) => axios.get(url("/design"), { params, headers }).then((r) => r.data),
    selection: () => axios.get(url("/selection"), { headers }).then((r) => r.data),
    op: (body) => axios.post(url("/selection/ops"), body, { headers }).then((r) => r.data),
    exportUrl: (fmt, sel) =>
      `${url(`/export.${fmt}`)}?revision=${sel.revision}&rate_version=${sel.versions.rate_version}&s=${encodeURIComponent(session)}`,
  };
}

export const newRequestId = () =>
  (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);

export const COLOR_OPTS = [
  { v: "Y", label: "Yellow Gold" },
  { v: "W", label: "White Gold" },
];
export const PURITY_OPTS = ["18KT", "14KT", "9KT"];
export const COLOR_NAME = { Y: "Yellow Gold", W: "White Gold", R: "Rose Gold", TT: "Two-Tone" };

export const inr = (v) =>
  v == null ? "—" : `₹${Number(v).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export async function downloadBlob(url, filename, headers) {
  const res = await axios.get(url, { responseType: "blob", headers });
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(href);
}
